'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _Controllable = require('../decorators/Controllable');

var _Controllable2 = _interopRequireDefault(_Controllable);

var _ShareInput = require('../decorators/ShareInput');

var _ShareInput2 = _interopRequireDefault(_ShareInput);

var _InputConstants = require('./InputConstants');

var _refObject = require('../utils/propTypes/refObject');

var _refObject2 = _interopRequireDefault(_refObject);

var _FieldsetContext = require('../context/FieldsetContext');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var UITextArea = function (_PureComponent) {
  _inherits(UITextArea, _PureComponent);

  function UITextArea() {
    _classCallCheck(this, UITextArea);

    return _possibleConstructorReturn(this, (UITextArea.__proto__ || Object.getPrototypeOf(UITextArea)).apply(this, arguments));
  }

  _createClass(UITextArea, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          className = _props.className,
          error = _props.error,
          inputRef = _props.inputRef,
          resize = _props.resize,
          styled = _props.styled,
          use = _props.use,
          rest = _objectWithoutProperties(_props, ['className', 'error', 'inputRef', 'resize', 'styled', 'use']);

      var fieldSize = this.context.size;


      var computedClassName = (0, _classnames2.default)('form-control', 'private-form__control', 'private-text-area', className, _InputConstants.INPUT_SIZE_OPTIONS[fieldSize], _InputConstants.USE_CLASSES[use], {
        'private-form__control--unstyled': !styled,
        'private-form__control--error': error,
        'private-text-area--no-resize': resize === false,
        'private-text-area--vertical-resize': resize === 'vertical',
        'private-text-area--horizontal-resize': resize === 'horizontal'
      });

      var renderedTextArea = _react2.default.createElement('textarea', _extends({}, rest, { className: computedClassName, ref: inputRef }));

      return renderedTextArea;
    }
  }]);

  return UITextArea;
}(_react.PureComponent);

UITextArea.contextType = _FieldsetContext.FieldsetContext;

UITextArea.displayName = 'UITextArea';

UITextArea.propTypes = {
  cols: _propTypes2.default.number,
  disabled: _propTypes2.default.bool,
  error: _propTypes2.default.bool,
  inputRef: _refObject2.default,
  placeholder: _propTypes2.default.string,
  readOnly: _propTypes2.default.bool,
  resize: _propTypes2.default.oneOf(['vertical', 'horizontal', true, false]),
  rows: _propTypes2.default.number,
  styled: _propTypes2.default.bool.isRequired,
  use: _propTypes2.default.oneOf(Object.keys(_InputConstants.USE_CLASSES)),
  value: _propTypes2.default.string
};

UITextArea.defaultProps = {
  error: false,
  resize: 'vertical',
  styled: true,
  value: ''
};

exports.default = (0, _ShareInput2.default)((0, _Controllable2.default)(UITextArea));
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/UIComponents/static-2.3620/js/input/UITextArea.js
// module id = 588
// module chunks = 177